import SaaCategory from "components/pages/saa/Category";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";

interface Props {
  isMobile: boolean;
}

const SaaLandingPage: NextPage<Props> = ({ isMobile }) => {
  return <SaaCategory isMobile={isMobile} />;
};
export default SaaLandingPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  return {
    props: {},
  };
}
